angular.module('lf.common')

.directive('cardValidExpirationDate', function () {
  return {
    require: '^form',
    link: function (scope, el, attrs, FormCtrl) {
      var client = lf.data.xhr.client;
      var isDesktop = client.isDesktop || client.isLFC;
      var watchValues = attrs.cardValidExpirationDate;
      var $errorMessage = el.find('.error-message_invalid-expiration-date');
      var $form = el.closest('form');
      var $fieldInputExpiresMonth = el.find('.field__input_expires-month');
      var $fieldInputExpiresYear = el.find('.field__input_expires-year');

      scope.$watch(watchValues, function (values) {
        if (values.length === 2 && values[0] && values[1]) {
          var now = new Date();
          var currentYear = now.getFullYear();
          var currentMonth = now.getMonth() + 1;
          var selectedMonth = parseInt(isDesktop ? values[0] : values[0].value);
          var selectedYear = parseInt(isDesktop ? values[1] : values[1].value);
          var invalid = selectedYear < currentYear || (selectedYear === currentYear && selectedMonth < currentMonth);
          
          if (invalid) {
            $errorMessage.show();
            FormCtrl.ccExpMonth.$setValidity('expirationDate', false);
            FormCtrl.ccExpYear.$setValidity('expirationDate', false);
            $fieldInputExpiresMonth.addClass('has-error');
            $fieldInputExpiresYear.addClass('has-error');
          } else {
            $errorMessage.hide();
            FormCtrl.ccExpMonth.$setValidity('expirationDate', true);
            FormCtrl.ccExpYear.$setValidity('expirationDate', true);
            if (_.isEmpty(FormCtrl.ccExpMonth.$error)) {
              $fieldInputExpiresMonth.removeClass('has-error');
            }
            if (_.isEmpty(FormCtrl.ccExpYear.$error)) {
              $fieldInputExpiresYear.removeClass('has-error');
            }
          }
        }
      }, true);
    }
  }
});
